<template>
	<ul class="drop-down" ref="dropDown" v-infinite-scroll="handleScroll" v-show="isShowList"
		v-click-outside="closeDropDown"
		:style="[styleObject, { maxHeight: isDoor ? '500px' : '' }]">
		<li class="search-user">
			<el-input ref="searchUser" v-model="searchKey" placeholder="请搜索" @keyup="searchUser">
				<template #prefix>
					<el-icon><Search /></el-icon>
				</template>
			</el-input>
		</li>
		<li class="drop-down-tips" v-if="contactList.length == 0" @click.stop>{{ tips }}</li>
		<template v-else>
			<li v-for="(user, index) in contactList"
				:class="['drop-down-item', isCheck(user) ? 'drop-down-item-active' : '']" @click.stop="change(index)"
				@mouseenter="showPopover(index)" @mouseleave="hidePopover(index)" :key="index">
				<div class="basic-info">
					<span v-if="isMultiple && isAppenSelect" class="icon-mutltiple"
						:class="isCheck(user) ? 'icon-active' : ''">
						<i class="iconfont el-icon-check"></i>
					</span>
					<span class="label-c" v-if="isShowLabel" :style="{
						backgroundColor: userLabel[user.type] && userLabel[user.type].background,
						color: userLabel[user.type] && userLabel[user.type].color
					}">{{ userLabel[user.type] && userLabel[user.type].label || '' }}</span>
					{{ user.name || user.realname }}{{ user.phone ? `(${user.phone})` : '' }}
				</div>
				<span class="more-tag" v-if="itemInfo && itemInfo.relationMoreTag && itemInfo.relationMoreTag !== ''">
					<template v-if="itemInfo.relationMoreTag === 'phone'">
						<userPhone :user="user" />
					</template>
					<template v-else>
						{{ getMoreTagContent(user, itemInfo.relationMoreTag) }}
					</template>
				</span>
				<el-popover placement="right" width="200" :value="popoverVisible[index]" trigger="manual">
					<p>姓名：{{ user.name || user.realname }}</p>
					<p>组织：{{ getOrgName(user) }}</p>
					<p>手机号：{{ user.phone }}</p>
					<template #reference>
						<span class="view-info"></span>
					</template>
				</el-popover>
			</li>
		</template>
	</ul>
</template>

<script>
import { debounce } from 'lodash'
import { getopenuserlist } from '@/port/clientSide/multipleChoice'
import { getusertiplist } from '@/port/admins/organizationUser'

import typeObj from "@/components/common/multipleChoice/color";
import { getOrgShowName } from '@/api/global.js'
import { cloneDeep } from 'lodash';
import { defineAsyncComponent } from 'vue';
import clickOutside from '@/directives/clickOutside'

export default {
	name: 'linkedDropDown',
	directives: {
		clickOutside
	},
	data() {
		return {
			data: {},
			contactLoading: false,
			contactList: [],
			isShowList: false,
			isShowLabel: true,
			tips: '加载中...',
			userLabel: '', // 用户标签
			activeIndex: '', // 选中的
			focus: false,
			downPosi: 'absolute',
			downWidth: '100%',
			dropDownLeft: 0,
			dropDownTop: '42px',
			curpage: 1,
			pagesize: 25,
			total: 0,
			organizationIdss: '', //自定义组织列表
			userids: '', //联动用户列表
			channel: '', //自定义&联动
			searchKey: '', //搜索关键字
			popoverVisible: {}, // 用于控制每个popover的显示状态
			isMultiple: false,
			userArr: [],
			maxCount: 100,
			userTag: 0
		}
	},
	props: {
		formdata: {

		},
		isDoor: {
			type: Boolean,
			default: false
		},
		itemInfo: {
			type: Object,
			default: () => { }
		},
		userPopWidth: {
			type: Number,
			default: 320
		},
		isAppenSelect: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		styleObject() {
			if (this.channel === 'cto' || this.channel === 'ctoAll') {
				return {
					position: this.downPosi,
					width: this.downWidth,
					bottom: this.dropDownTop,
					left: this.dropDownLeft,
				};
			}
			else {
				return {
					position: this.downPosi,
					width: this.downWidth,
					top: this.dropDownTop,
					left: this.dropDownLeft,
				};
			}
		},
	},
	components: {
		userPhone: defineAsyncComponent(() => import('@/components/clientSide/formFillinPageChild/widget/cpns/userPhone.vue')),
	},
	methods: {
		getOrgName(user) {
			const li = user.orglst
			if (!li) return user.orgname || user['部门']
			return getOrgShowName(li[0])
		},
		isCheck(item) {
			const arr = Array.isArray(this.userArr) ? this.userArr : []
			let flag = arr.find(f=>f.userId === item.userId)
			return Boolean(flag)
		},
		// 根据联动结果获取用户详细信息
		async getList(data, list, params, detailInfo, searchKey) {
			console.log("channel==", params);
			this.data = data;
			this.isShowList = true;
			this.organizationIdss = '';
			this.userids = '';
			this.channel = params.channel;
			this.userTag = data.userTag || 0
			this.curpage = 1;
			this.contactList = [];
			this.searchKey = '';
			if (params.channel !== 'cto' && params.channel !== 'ctoAll') {
				document.body.appendChild(this.$refs.dropDown)
			}
			if (params.parentDiv) {
				this.downPosi = 'fixed';
				this.downWidth = params.parentDiv.offsetWidth < 320 ? '320px' : params.parentDiv.offsetWidth + 'px'
				this.dropDownLeft = params.parentDiv.getBoundingClientRect().left + 'px'
				this.dropDownTop = params.parentDiv.getBoundingClientRect().top + 44 + 'px'
			}
			console.log("data===", data)
			// 是否搜索过来
			if (searchKey) {
				this.searchKey = searchKey;
			}
			// 是否明细控件
			if (detailInfo) {
				this.downPosi = 'fixed';
				this.dropDownLeft = detailInfo.left + 'px'
				this.dropDownTop = detailInfo.top + 40 + 'px'
				this.downWidth = detailInfo.width < 320 ? '320px' : detailInfo.width - 2 + 'px'
			}
			if (this.isDoor && this.userPopWidth > 320) {
				this.downWidth = this.userPopWidth + 'px'
			}
			if (list && list.length > 0) {
				if (params.channel === 'custom') {
					let organizationIdss = list.map(item => item.organizationId)
					this.organizationIdss = organizationIdss.join(',');
				}
				else {
					let userids = list.map(item => item.userId)
					this.userids = userids.join(',');
				}
				this.getUserList()
			}
			else {
				this.tips = '暂无数据'
				this.isShowList = true;
			}
			// 触发搜索输入框焦点
			this.$nextTick(() => {
				setTimeout(() => {
					if (this.$refs.searchUser) {
						this.$refs.searchUser.focus();
					}
				}, 500);
			});
		},
		// 联系人控件-查找优化
		async getNewList(data, params, detailInfo, searchKey) {
			console.log("data==", data);
			console.log("channel====", params);
			this.data = data;
			this.isShowList = true;
			this.organizationIdss = '';
			this.userids = '';
			this.channel = params.channel;
			this.curpage = 1;
			this.userTag = data.userTag || 0
			this.contactList = [];
			this.searchKey = '';
			if (params.channel !== 'cto' && params.channel !== 'ctoAll') {
				document.body.appendChild(this.$refs.dropDown)
			}
			if (params.parentDiv) {
				this.downPosi = 'fixed';
				this.downWidth = params.parentDiv.offsetWidth < 320 ? '320px' : params.parentDiv.offsetWidth + 'px'
				this.dropDownLeft = params.parentDiv.getBoundingClientRect().left + 'px'
				this.dropDownTop = params.parentDiv.getBoundingClientRect().top + 44 + 'px'
			}
			// 是否搜索过来
			if (searchKey) {
				this.searchKey = searchKey;
			}
			if (this.isDoor && this.userPopWidth > 320) {
				this.downWidth = this.userPopWidth + 'px'
			}
			// 是否明细控件
			if (detailInfo) {
				this.downPosi = 'fixed';
				this.dropDownLeft = detailInfo.left + 'px'
				this.dropDownTop = detailInfo.top + 40 + 'px'
				this.downWidth = detailInfo.width < 320 ? '320px' : detailInfo.width - 2 + 'px'
			}
			// 触发搜索输入框焦点
			this.$nextTick(() => {
				setTimeout(() => {
					if (this.$refs.searchUser) {
						this.$refs.searchUser.focus();
					}
				}, 500);
			});
			this.getUserList()
		},
		// 获取用户标签
		async getUserType() {
			const res = await getusertiplist({
				curpage: 1,
				pagesize: 99999
			})
			if (res.code === 0) {
				const obj = {}
				for (const i of res.data) {
					obj[i.keytype] = {
						label: i.name,
						color: typeObj[i.colours].color,
						background: typeObj[i.colours].background
					}
				}
				this.userLabel = obj
			}
		},
		searchUser(){
			this.debouncedSearchUser()
		},
		// 创建防抖函数
		debouncedSearchUser: debounce(function() {
			this.curpage = 1
			this.contactList = []
			console.log("this.optSearch==", this.optSearch, this.searchKey);
			this.getUserList()
		}, 300), // 300ms 延迟
		handleScroll() {
			if (this.contactLoading || this.total === 0) return
			this.curpage++
			this.getUserList()
		},
		// 获取用户列表
		async getUserList() {
			const query = {
				curpage: this.curpage,
				pagesize: this.pagesize
			}
			console.log("this.channel==", this.channel, this.searchKey);
			if (this.searchKey) {
				query.names = this.searchKey
			}
			if (this.channel === 'custom') {
				query.organizationids = this.organizationIdss
			}
			else if (this.channel === 'newList' || this.channel === 'cto') {
				console.log("222", this.data);

				// 联系人控件-查找优化
				if (this.data.lookRMSIsUser === 1 || this.data.lookRMSIsUser === 2) {
					query.orgtype = this.data.lookRMSIsUser
				}
				else if (this.data.lookRMSIsUser === 4 || this.channel === 'cto') {
					const list = typeof this.data.lookCustomArr === 'string' ? JSON.parse(this.data.lookCustomArr) : this.data.lookCustomArr
					if (list.length > 0) {
						let organizationsId = list.map(item => item.organizationId)
						// 联系人控件-部门查看范围-自定义（是否选择子部门）
						if (this.data && !this.data.lookCustomChild && this.channel !== 'cto') {
							query.organizationIdss = organizationsId.join(',');
						}
						else {
							query.organizationsId = organizationsId.join(',');
						}
					}
				}
				if (this.data.lookRMSIsUserRole === 1) {
					query.roletype = 1
				}
				else if (this.data.lookRMSIsUserRole === 3 || this.channel === 'cto') {
					const list = typeof this.data.lookCustomArrRole === 'string' ? JSON.parse(this.data.lookCustomArrRole) : this.data.lookCustomArrRole
					if (list.length > 0) {
						let roleId = list.map(item => item.roleId)
						query.rolesId = roleId.join(',');
					}
				} else if (this.data.lookRMSIsUser === 6) {
					query.manage = 1
					if (this.data.iManageIt && this.data.iManageIt.length > 0) {
						query.deptIds = this.data.iManageIt.join(',')
					}
				}
			}
			else if (this.channel === 'ctoAll') {
				console.log('ctoAll');
			}
			else {
				if(!this.userids) return //联动返回的结果如果是空值，则不调接口
				query.userids = this.userids
			}
			if (this.contactLoading) return
			if (this.total !== 0 && this.contactList.length >= this.total) return
			this.contactLoading = true
			if (this.userTag !== 0) {
				query.type = this.userTag
			}
			const res = await getopenuserlist(query)
			document.addEventListener('click', this.closeDropDown)
			this.isShowList = true;
			this.contactLoading = false
			if (res.code === 0) {
				this.total = res.total
				if(this.searchKey){
					this.contactList = res.data
				}
				else{
					this.contactList.push(...res.data)
				}
				this.$emit('contactList', this.contactList)
				if(res.data.length === 0 && res.curpage === 1){
					this.tips = '暂无数据'
				}
				// 触发搜索输入框焦点
				this.$nextTick(() => {
					setTimeout(() => {
						if (this.$refs.searchUser) {
							this.$refs.searchUser.focus();
						}
					}, 500);
				});
				console.log("this.itemInfo==",this.itemInfo);
			}
		},
		// 关闭列表
		closeDropDown(e) {
			// 检查点击的是否是 .search 区域或其子元素
			if (e.target.closest('.search-user')) {
                return; // 如果是搜索区域，不关闭下拉框
            }
			this.isShowList = false
		},
		// 选择
		change(index) {
			this.activeIndex = index
			const checkUser = this.contactList[index]
			// 是否支持多选
			if (this.isMultiple && this.isAppenSelect) {
				const userArrIndex = this.userArr.findIndex(item => { return item.userId === checkUser.userId })
				if (userArrIndex === -1) {
					if (this.userArr.length >= this.maxCount) {
						this.$message.warning(`最大人数不能超过${this.maxCount}人`)
					} else {
						this.userArr.push(checkUser)
					}
				} else {
					this.userArr.splice(userArrIndex, 1)
				}
				this.$emit('userCheck', { user: this.userArr, data: this.data })

				// const isCheck = this.formdata.some(item => {
				// 	return this.userArr.find(iten => { return item.userId === iten.userId })  
				// })
				// this.userArr = isCheck ? this.formdata : [...this.formdata, ...this.userArr]
			} else {
				this.userArr = [checkUser]
				this.submit()
			}

		},
		submit() {
			this.$emit('userCheck', { user: this.userArr, data: this.data })
			// 关闭重置
			if (!this.isDoor) {
				this.isShowList = false
			}
			this.activeIndex = ''
			this.tips = '加载中...'
		},
		// 键盘选择
		keyChange(e) {
			switch (e.keyCode) {
				// 上
				case 38: {
					this.activeIndex > 0 ? this.activeIndex-- : ''
					break
				}
				// 下
				case 40: {
					this.activeIndex < this.contactList.length - 1 ? this.activeIndex++ : ''
					break
				}
				// 回车
				case 13: {
					console.log('回车');
					this.change(this.activeIndex)
					break
				}
			}
		},
		showPopover(index) {
			// this.$set(this.popoverVisible, index, true)
			this.popoverVisible[index] = true
		},
		hidePopover(index) {
			// this.$set(this.popoverVisible, index, false)
			this.popoverVisible[index] = false
		},
		// 更多标签显示
		getMoreTagContent(user, relationMoreTag) {
			if (relationMoreTag === 'sex') {
				return user[relationMoreTag] === 0 ? '男' : '女'
			} else if (relationMoreTag === 'orgname' || relationMoreTag === '部门') {
				// const content = user[relationMoreTag] || ''
				// return content.includes(',') ? content.split(',')[0] : content
				return this.getOrgName(user)
			} else {
				return user[relationMoreTag]
			}
		},
	},
	watch: {
		formdata: {
			handler(val) {
				this.userArr = cloneDeep(val)
			},
			immediate: true,
			deep: true
		},
		'itemInfo.singleIsUser': {
			handler(val) {
				this.isMultiple = val === 1 ? true : false
			},
			immediate: true,
		},
    'itemInfo.maxCount': {
			handler (val) {
				this.maxCount = Number(val)
			},
			immediate: true,
		}
	},

	mounted() {
		this.getUserType()
		document.addEventListener('click', this.closeDropDown)

	},
	beforeUnmount() {
		document.removeEventListener('click', this.closeDropDown)
		if (this.channel !== 'cto' && this.channel !== 'ctoAll') {
			// 检查元素是否存在且是 body 的子元素
			const dropDown = this.$refs.dropDown
			if (dropDown && dropDown.parentNode === document.body) {
				document.body.removeChild(dropDown)
			}
		}
	},

}
</script>

<style lang="scss" scoped>
:deep(.el-input .el-input__inner) {
	border: none !important;
}

:deep(.el-tag) {
	margin-left: 10px;
}

::-webkit-scrollbar {
	/*滚动条整体样式*/
	width: 4px;
	/*高宽分别对应横竖滚动条的尺寸*/
	height: 1px;
}

::-webkit-scrollbar-thumb {
	/*滚动条里面小方块*/
	border-radius: 10px;
	box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
	background: #4dabee;
}

::-webkit-scrollbar-track {
	/*滚动条里面轨道*/
	box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
	border-radius: 10px;
	background: #ededed;
}

.drop-down {
	width: inherit;
	max-height: 200px;
	overflow: hidden;
	overflow-y: auto;
	padding: 40px 0px 6px;
	background: #FFF;
	border: 1px solid #E4E7ED;
	border-radius: 4px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	z-index: 4999;

	&::before {
		display: block;
		content: " ";
		position: absolute;
		top: -4px;
		left: 40px;
		width: 6px;
		height: 6px;
		background: #FFF;
		border-left: 1px solid #E4E7ED;
		border-top: 1px solid #E4E7ED;
		transform: rotate(45deg);
	}

	li {
		height: 40px;
		line-height: 40px;
		clear: both;
		overflow: hidden;
	}

	&-tips {
		text-align: center;
	}

	&-item {
		list-style: none;
		padding: 0 7px 0 10px;
		cursor: pointer;

		.icon-mutltiple {
			width: 18px;
			height: 18px;
			border: 2px solid rgba(23, 26, 29, 0.24);
			display: inline-block;
			box-sizing: border-box;
			line-height: normal;
			float: left;
			margin: 10px 5px 0 0;
			.el-icon-check {
				color: rgba(0, 0, 0, 0);
				font-size: 14px;
			}
		}

		.icon-active {
			background-color: #4E86FF;
			border-color: #4E86FF;

			.el-icon-check {
				color: #FFF;
			}
		}

		.label-c {
			font-size: 12px;
			padding: 2px 4px;
		}

		.basic-info {
			float: left;
			font-size: 14px;
		}

		.more-tag {
			float: left;
			display: inline-block;
			max-width: 40%;
			margin: 11px 0 0 10px;
			height: 18px;
			line-height: 18px;
			text-align: center;
			color: #3AB380;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
			background-color: rgba(112, 255, 189, 0.1);
		}

		.view-info {
			color: #057EFF;
			font-size: 12px;
			float: right;
			height: 40px;
			line-height: 40px;
		}

		&:hover {
			background: rgb(245, 247, 250);
			font-weight: 700;
			color: #4e86ff;
		}

	}

	&-item-active {
		background: rgb(245, 247, 250);
		font-weight: 700;
		color: #4e86ff;
	}
	.search-user {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 41px;
		padding: 0 5px;
		box-sizing: border-box;
		background: #fff;
		:deep(.el-input__wrapper) {
			box-shadow: none;
		}
		:deep(.el-input__inner) {
			border-bottom: 1px solid #DCDFE6 !important;
			border-radius: 0;
		}
	}
}
</style>
